import React, { useState } from "react";
import { forgotPassword, resetPassword } from "../../api"; // Import correct API functions
import { FaSpinner } from "react-icons/fa";

const ForgotOrResetPasswordForm = ({ onResetSuccess }) => {
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState(null);
  const [isResetMode, setIsResetMode] = useState(false);

  const handleForgotPasswordSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setMessage(null);

    try {
      await forgotPassword({ email });
      setMessage({
        type: "success",
        text: "An OTP has been sent to your email. Enter it below to reset your password.",
      });
      setIsResetMode(true);
    } catch (error) {
      setMessage({
        type: "error",
        text: error.response?.data?.message || "An error occurred. Try again.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleResetPasswordSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setMessage(null);

    try {
      if (password !== confirmPassword) {
        setMessage({ type: "error", text: "Passwords do not match." });
        setIsSubmitting(false);
        return;
      }
      await resetPassword({ email, otp, password });
      setMessage({
        type: "success",
        text: "Password reset successfully. Redirecting to login...",
      });

      // Call the onResetSuccess callback to show the login form
      setTimeout(() => onResetSuccess(), 2000);
    } catch (error) {
      setMessage({
        type: "error",
        text: error.response?.data?.message || "An error occurred. Try again.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center bg-gradient-to-r from-blue-500 to-purple-500 p-4 min-h-screen">
      <div className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full">
        <h2 className="text-2xl font-bold text-gray-700 mb-6 text-center">
          {isResetMode ? "Reset Password" : "Forgot Password"}
        </h2>
        <form
          className="space-y-4"
          onSubmit={isResetMode ? handleResetPasswordSubmit : handleForgotPasswordSubmit}
        >
          {!isResetMode && (
            <>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                Email Address
              </label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                required
                className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </>
          )}
          {isResetMode && (
            <>
              <label htmlFor="otp" className="block text-sm font-medium text-gray-700">
                OTP
              </label>
              <input
                type="text"
                id="otp"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                placeholder="Enter OTP sent to your email"
                required
                className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                New Password
              </label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter new password"
                required
                className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <label htmlFor="confirmPassword" className="block text-sm font-medium text-gray-700">
                Confirm New Password
              </label>
              <input
                type="password"
                id="confirmPassword"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="Confirm new password"
                required
                className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </>
          )}
          <button
            type="submit"
            disabled={isSubmitting}
            className="w-full bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            {isSubmitting ? (
              <FaSpinner className="animate-spin mx-auto" />
            ) : isResetMode ? (
              "Reset Password"
            ) : (
              "Send OTP"
            )}
          </button>
        </form>
        {message && (
          <p
            className={`mt-4 text-center font-medium ${
              message.type === "success" ? "text-green-500" : "text-red-500"
            }`}
          >
            {message.text}
          </p>
        )}
      </div>
    </div>
  );
};

export default ForgotOrResetPasswordForm;
